import React from 'react';
import API, { ThenArg } from '../../services/API';
import styled from 'styled-components';

import { TotalPriceCart } from './Cart1Styles';
import { __ } from '@bart.sk-eshop/react-i18n';
import { rem } from 'polished';
import {
  formatPrice,
  isCompany,
  notLoggedOrRetail,
  showPriceWithVat,
} from '../../utilities';

interface TotalPriceCartComponenSideProps {
  cart: ThenArg<typeof API.getCart>;
  user: any;
  dispatch: any;
  onDemandCartItems: ThenArg<typeof API.getCart>['items'];
  regularCartItems: ThenArg<typeof API.getCart>['items'];
  size?: string;
}

export const TotalPriceCartComponentSide: React.FC<
  TotalPriceCartComponenSideProps
> = ({ cart, user, onDemandCartItems }) => {
  const showWithVat = showPriceWithVat(user);
  const company = isCompany(user);
  const isDiscount =
    (cart.customer_card_discount && cart.customer_card_discount > 0) ||
    (cart.giftcards && cart.giftcards.length);

  return (
    <TotalPriceCartSide>
      {cart.discount_save > 0 ? (
        <TotalPriceRow className={'discount'}>
          <TotalPriceText>
            {__('Ušetrili ste')}
            {!showWithVat ? ' ' + __('(s DPH)') : ''}
          </TotalPriceText>
          <PriceCartWithoutVat>
            {formatPrice(cart.discount_save, 'EUR')}
          </PriceCartWithoutVat>
        </TotalPriceRow>
      ) : (
        ''
      )}
      {showWithVat ? (
        <>
          {company ? (
            <TotalPriceRow>
              <TotalPriceText>{__('Celkom bez DPH')}</TotalPriceText>
              <PriceCartWithoutVat>
                {formatPrice(
                  cart.total_items_price_with_discount_without_vat || 0,
                  'EUR',
                )}
              </PriceCartWithoutVat>
            </TotalPriceRow>
          ) : (
            ''
          )}

          {notLoggedOrRetail(user) ? (
            <TotalPriceRow>
              <TotalPriceText>{__('Spolu')}</TotalPriceText>
              <PriceCart>
                {formatPrice(cart.total_items_price_with_discount || 0, 'EUR')}
              </PriceCart>
            </TotalPriceRow>
          ) : (
            <TotalPriceRow>
              <TotalPriceText>{__('Celkom s DPH')}</TotalPriceText>
              <PriceCart>
                {formatPrice(cart.total_items_price_with_discount || 0, 'EUR')}
              </PriceCart>
            </TotalPriceRow>
          )}
        </>
      ) : (
        <>
          {company ? (
            <TotalPriceRow>
              <TotalPriceText>{__('Celkom bez DPH')}</TotalPriceText>
              <PriceCart>
                {formatPrice(
                  isDiscount
                    ? cart.total_items_price_with_discount_without_vat || 0
                    : cart.total_items_price_without_vat || 0,
                  'EUR',
                )}
              </PriceCart>
            </TotalPriceRow>
          ) : (
            ''
          )}
          <TotalPriceRow>
            <TotalPriceText>{__('Celkom s DPH')}</TotalPriceText>
            <PriceCartWithoutVat>
              {formatPrice(
                isDiscount
                  ? cart.total_items_price_with_discount || 0
                  : cart.total_items_price || 0,
                'EUR',
              )}
            </PriceCartWithoutVat>
          </TotalPriceRow>
        </>
      )}
      {onDemandCartItems.length ? (
        <ProductOnDemandInfoText>
          {__('Cena celkom nezahŕňa produkty na dopyt')}
        </ProductOnDemandInfoText>
      ) : (
        ''
      )}
    </TotalPriceCartSide>
  );
};

const TotalPriceCartSide = styled(TotalPriceCart)`
  width: 100%;
  margin: 0;
`;

const TotalPriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &.discount {
    color: ${({ theme }) => theme.color.success};
  }
`;

export const PriceCartWithoutVat = styled.div`
  font-size: ${rem(16)};
  font-weight: bold;
`;

const ProductOnDemandInfoText = styled.p`
  margin-top: 12px;
  margin-bottom: 12px;
  color: #4d94ff;
  font-weight: bold;
  text-align: right;
`;

const TotalPriceText = styled.div`
  font-size: ${rem(16)};
  margin-right: ${rem(10)};
  white-space: nowrap;
`;

export const PriceCart = styled.div`
  font-size: ${rem(16)};
  font-weight: bold;
`;
